<ng-container *ngIf="dataBlocks && dataBlocks.length; else noData">
    <ng-container *ngFor="let block of dataBlocks">
        <h3>
            {{ block.text.shortLabel }}
            <app-tooltip [text]="block.text.summary"></app-tooltip>
        </h3>
        <app-overview-datatable [overview]="block"></app-overview-datatable>
    </ng-container>
</ng-container>

<ng-template #noData>
    <p>{{'invest.eval.noData.summary' | translate}}</p>
</ng-template>
